module.exports = __webpack_public_path__ + "static/media/video_conferencing_system.30222258.svg";